var _defs, _g, _text;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 284,
    height: 94,
    viewBox: "0 0 284 94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Clip_2",
    "data-name": "Clip 2",
    d: "M0,0H58.981V16.8H0Z",
    transform: "translate(0 0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8",
    transform: "translate(3 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24",
    "data-name": "Group 24",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Clip_2-2",
    "data-name": "Clip 2",
    d: "M0,0H58.981V16.8H0Z",
    transform: "translate(0 0)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_24-2",
    "data-name": "Group 24",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23",
    "data-name": "Group 23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_1",
    "data-name": "Fill 1",
    d: "M17.839,16.81H0V0H17.839V16.809ZM4.688,2.367V14.449H9.545a5.83,5.83,0,0,0,2.053-.431A3.068,3.068,0,0,0,13.6,11.039a2.95,2.95,0,0,0-.294-1.25,3.332,3.332,0,0,0-2.344-1.767A2.7,2.7,0,0,0,12.508,5.6a2.926,2.926,0,0,0-.359-1.485A3.745,3.745,0,0,0,8.926,2.367Zm4.5,10.216H6.839v-3.3h2.3a2.457,2.457,0,0,1,1.838.607,1.453,1.453,0,0,1,.4.976C11.385,12.5,9.551,12.583,9.183,12.583Zm-.869-5.21H6.839V4.248H8.572c1.423.075,1.755.97,1.732,1.434C10.3,7.327,8.334,7.373,8.314,7.373Z",
    transform: "translate(20.571 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3",
    "data-name": "Fill 3",
    d: "M17.839,16.81H0V0H17.839V16.809ZM4.688,2.367V14.449H9.545a5.83,5.83,0,0,0,2.053-.431A3.068,3.068,0,0,0,13.6,11.039a2.95,2.95,0,0,0-.294-1.25,3.332,3.332,0,0,0-2.344-1.767A2.7,2.7,0,0,0,12.508,5.6a2.926,2.926,0,0,0-.359-1.485A3.745,3.745,0,0,0,8.926,2.367Zm4.5,10.216H6.839v-3.3h2.3a2.457,2.457,0,0,1,1.838.607,1.453,1.453,0,0,1,.405.976C11.385,12.5,9.551,12.583,9.183,12.583Zm-.869-5.21H6.839V4.248H8.572c1.423.075,1.755.97,1.732,1.434C10.3,7.327,8.334,7.373,8.314,7.373Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_4",
    "data-name": "Fill 4",
    d: "M17.839,16.81H0V0H17.839V16.809ZM9.714,2.217A7.44,7.44,0,0,0,7.3,2.543,6.319,6.319,0,0,0,3.207,6.022a6.142,6.142,0,0,0-.521,2.383,6.209,6.209,0,0,0,1.9,4.4,5.9,5.9,0,0,0,1.8,1.187,9.061,9.061,0,0,0,3.342.635,9.842,9.842,0,0,0,4.572-1.135V11.175a8.541,8.541,0,0,1-4.473,1.513,2.616,2.616,0,0,1-.275-.012,4.685,4.685,0,0,1-4.121-2.222,4.439,4.439,0,0,1-.519-2.05,4.071,4.071,0,0,1,2.29-3.737A5.838,5.838,0,0,1,9.593,4.1h.02A10.259,10.259,0,0,1,14.2,5.466V3.234a13.094,13.094,0,0,0-3.342-.961C10.47,2.236,10.085,2.217,9.714,2.217Z",
    transform: "translate(41.142 0)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("text", {
    id: "COUNTRYFILE",
    transform: "translate(-3 58)",
    fill: "#fff",
    fontSize: 40,
    fontFamily: "Helvetica"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "COUNTRY"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    fontFamily: "Helvetica-Bold, Helvetica",
    fontWeight: 700
  }, "FILE")))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "WILD_BRITAIN",
    "data-name": "WILD BRITAIN",
    transform: "translate(3 88)",
    fill: "#fff",
    fontSize: 24,
    fontFamily: "Helvetica-Bold, Helvetica",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "WILD BRITAIN"))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d5efd4d529768622d9c5083f36c047d5.svg";
export { ForwardRef as ReactComponent };